import { ISectionSpec } from 'components/SectionHeader'
import SalesRepSetup from 'layouts/SalesRepSetup'
import SalesUsageReport from 'layouts/SalesUsageReport'
import TeamReport from 'layouts/TeamReport'

export const TEAMS: ISectionSpec = {
  basePath: 'team',
  baseTitle: 'Team performance',
  sections: [
    {
      showDatePicker: true,
      path: () => '/overview',
      title: () => 'Overview',
      component: TeamReport,
    },
    {
      showDatePicker: false,
      path: () => '/sales-setup',
      title: () => 'Sales Rep setup',
      component: SalesRepSetup,
    },
    {
      showDatePicker: true,
      path: () => '/sales-usage',
      title: () => 'Sales Rep usage',
      component: SalesUsageReport,
    },
  ],
}
